import httpApi from '../api/httpApi';
import useSWR from 'swr';
import {
    ProductSearchParams,
    ProductsResponse,
} from '../../models/ProductSearch';

const FILTER_URL = '/api/v1/products';

const useProductFilterSWR = (filter: ProductSearchParams) => {
    const fetch = (query, filter): Promise<ProductsResponse> => {
        return httpApi
            .post<ProductsResponse>(query, filter)
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        [FILTER_URL, filter],
        ([url, filter]) => fetch(url, filter),
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        products: data ? data.products : null,
        count: data ? data.count : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useProductFilterSWR;
